import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import customerDetailModel from "@/models/data-management/customer-detail";
import router from "@/router";
import store from "@/store";
import { onBeforeMount, reactive } from "@vue/composition-api";

export default function useOverallPrivilege() {
  const { fetchOverallPrivilege } = customerDetailModel();
  const {
    openWarningModal,
    openSuccessModal,
    openDefaultErrorModal,
  } = useValidationModal();

  const formData = reactive({
    customerId: 0,
    tierId: 0,
    point: null,
    expDate: null,
    tierTh: null,
    tierEn: null,
  });

  const fetchDetailData = () => {
    // window.$loading(true)
    fetchOverallPrivilege.payload.Customer_Id = formData.customerId;
    store
      .dispatch("api/apiRequest", fetchOverallPrivilege)
      .then((resp) => {
        const respData = resp.data.resp;

        formData.tierId = respData.mbs_tier_id;
        formData.point = respData.crm_point;
        if (respData.exp_date != null)
          formData.expDate = resolveDate(respData.exp_date);
        formData.tierTh = respData.mbs_tier_th;
        formData.tierEn = respData.mbs_tier_en;
      })
      .catch((err) => {
        openDefaultErrorModal();
      })
      .finally(() => {
        // window.$loading(false)
      });
  };

  const resolveDate = (date) => {
    const dateObject = new Date(date);

    return `${dateObject.getDate()} ${dateObject.toLocaleString("default", {
      month: "long",
    })} ${dateObject.getFullYear()}`;
  };

  onBeforeMount(() => {
    if (!router.currentRoute.query.customerid) return;
    formData.customerId = parseInt(router.currentRoute.query.customerid);
    fetchDetailData();
  });

  return { formData };
}
